export default __webpack_public_path__ + "static/media/deleteFile.0c24ebb6.svg";